<h2 mat-dialog-title class="dialog-title">Dokumentations-Chat
    <button style="margin-left: auto;" (click)="this.dialogRef.close()" mat-icon-button><mat-icon>close</mat-icon></button>
</h2>
<div mat-dialog-content class="dialog-content">
    <div class="chat-container">
        <aside class="conversation-list">
            <button type="button" class="one-row" (click)="startNewConversation()" mat-button [disabled]="isLoadingConversations() || isSavingConversation()">
                Neuer Chat <mat-icon>add</mat-icon>
            </button>
            <div class="conversation-list__header">
                <h3>Verläufe</h3>
                @if(isLoadingConversations()){
                    <span class="conversation-list__status">Laden …</span>
                }
            </div>
            <div class="conversation-list__items">
                @if(!conversations.length && !isLoadingConversations()){
                    <p class="conversation-list__empty">Noch keine Unterhaltungen.</p>
                }
                @for(conversation of conversations; track conversation) {
                    <div class="conversation-item" [class.conversation-item--active]="conversation.id === activeConversation()?.id">
                        <button
                            type="button"
                            class="conversation-item__content"
                            (click)="selectConversation(conversation)"
                            [disabled]="isSavingConversation()"
                        >
                            <div class="conversation-item__title">{{ conversation.name || 'Neue Unterhaltung' }}</div>
                            <div class="conversation-item__timestamp">{{ conversation.createdAt | date: 'short' }}</div>
                        </button>
                        <button
                            type="button"
                            mat-icon-button
                            class="conversation-item__menu-trigger"
                            [matMenuTriggerFor]="conversationMenu"
                            [disabled]="isSavingConversation()"
                            (click)="$event.stopPropagation()"
                            aria-label="Konversation verwalten"
                        >
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #conversationMenu="matMenu">
                            <button mat-menu-item (click)="renameConversation(conversation)" [disabled]="isSavingConversation()">
                                <mat-icon>edit</mat-icon>
                                Umbenennen
                            </button>
                            <button mat-menu-item (click)="deleteConversation(conversation)" [disabled]="isSavingConversation()">
                                <mat-icon>delete</mat-icon>
                                Löschen
                            </button>
                        </mat-menu>
                    </div>
                }
            </div>
        </aside>
        <section class="chat-panel">
            @for (conversation of openedConversations; track conversation.id) {
                <phito-chat-window
                    [conversation]="conversation"
                    (titleChanged)="conversation.name = $event"
                    [class.is-active]="conversation.id === activeConversation()?.id"
                ></phito-chat-window>
            }
        </section>
    </div>
</div>
